import React, { useEffect } from 'react';
import { CustomInputProps, InputProps } from '../../models/type';
import { useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import clientUtils from '../../Utils/clientUtils';

const CustomInput = ({  name, label, typeValue, ...props }: InputProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // useEffect(() => {
  //   console.log('Custom Input props changed', props);
  // }, [props]);
  const error = errors[name]?.message as string | undefined;
  const id = `${name}-${props.type}-${label}`;

  const onKeyPress = (event) => {
    if (typeValue === 'number') {
      return clientUtils.keypress(event);
    }
  };
  const getInputLableProps = (value: string) => {
    // console.log(value)
    if (value) {
      return { shrink: true };
    }
    return {};
  };

  return (
    <>
      {props.isMultiline ? (
        <>
          <TextField
            id={id}
            label={label}
            defaultValue={props.value}
            helperText={error ? error : props.description}
            variant="outlined"
            placeholder={props.placeholder}
            size="small"
            fullWidth
            multiline
            rows={5}
            error={Boolean(errors[name])}
            onKeyPress={onKeyPress}
            disabled={props.disabled}
            {...register(name)}
            InputLabelProps={getInputLableProps(props.value)}
            InputProps={{
              style: {
                marginBottom: props.description || error ? '0px' : '10px',
              },
            }}
          />
        </>
      ) : (
        <>
          <TextField
            id={id}
            label={label}
            defaultValue={props.value}
            helperText={error ? error : props.description}
            variant="outlined"
            placeholder={props.placeholder}
            size="small"
            fullWidth
            error={Boolean(errors[name])}
            onKeyPress={onKeyPress}
            disabled={props.disabled}
            {...register(name)}
            InputLabelProps={getInputLableProps(props.value)}
            InputProps={{
              style: {
                marginBottom: props.description || error ? '0px' : '10px',
              },
            }}
          />
        </>
      )}
    </>
  );
};

export default CustomInput;
